import type { RouteFromGeometryRequest, Waypoint } from '@xingroute/schema'
import { toGpx } from './gpx.js'
import { safeDownloadBasename } from './kml.js'

export function drawnRequestToGpxFile(
  request: RouteFromGeometryRequest,
  fallbackName: string,
): File | null {
  if (!request.line || request.line.length < 2) return null
  const name = request.title?.trim() || fallbackName || 'route'
  const gpx = toGpx(
    request.line.map((point) => ({ lat: point.lat, lon: point.lon })),
    name,
    (request.points ?? []).map(
      (point): Waypoint => ({
        id: '',
        lat: point.lat,
        lon: point.lon,
        auto: false,
        ...(point.name !== undefined ? { name: point.name } : {}),
        ...(point.desc !== undefined ? { desc: point.desc } : {}),
        ...(point.kind !== undefined ? { kind: point.kind } : {}),
      }),
    ),
  )
  return gpxFileFromText(gpx, name)
}

function gpxFileFromText(gpx: string, name: string): File {
  const safe = safeDownloadBasename(name, 'route').slice(0, 60)
  return new File([gpx], `${safe}.gpx`, { type: 'application/gpx+xml' })
}
